import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientComponent } from './client.component';
import { ClaimActiveGuard } from './guards/claim-active.guard';
import { GuideGuardService } from './guards/guide.guard';
import { CaseComponent } from './pages/case/case.component';
import { CasesComponent } from './pages/cases/cases.component';
import { ClaimComponent } from './pages/claim/claim.component';
import { CommunicationsComponent } from './pages/communications/communications.component';
import { DetailsCommunicationComponent } from './pages/communications/details-communication/details-communication.component';
import { NewCommunicationComponent } from './pages/communications/new-communication/new-communication.component';
import { FaqComponent } from './pages/faq/faq.component';
import { GuideComponent } from './pages/guide/guide.component';
import { HomeComponent } from './pages/home/home.component';
import { NewsDetailsComponent } from './pages/news/components/news-details/news-details.component';
import { NewsSearchComponent } from './pages/news/components/news-search/news-search.component';
import { NewsComponent } from './pages/news/news.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { QuestionnaireAnswerClientComponent } from './pages/questionnaire-answer-client/questionnaire-answer-client.component';
import { RedirectingComponent } from './pages/redirecting/redirecting.component';
import { ThreadComponent } from './pages/thread/thread.component';
import { UnsavedChangesGuard } from 'src/app/core/guards/unsaved-changes.guard';

const routes: Routes = [
  {
    path: 'redirecting',
    component: RedirectingComponent,
  },
  {
    path: '',
    component: ClientComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'news',
        component: NewsComponent,
        canActivate: [GuideGuardService],
      },
      {
        path: 'news/search',
        component: NewsSearchComponent,
        canActivate: [GuideGuardService],
      },
      {
        path: 'news/:id',
        component: NewsDetailsComponent,
        canActivate: [GuideGuardService],
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [GuideGuardService],
      },
      {
        path: 'cases',
        component: CasesComponent,
        canActivate: [GuideGuardService],
      },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [GuideGuardService],
      },
      {
        path: 'cases/:id',
        component: CaseComponent,
        canActivate: [GuideGuardService],
      },
      {
        path: 'claim/:claimId/guide',
        component: GuideComponent,
        canActivate: [ClaimActiveGuard],
        canDeactivate: [UnsavedChangesGuard],
      },
      {
        path: 'claim/:id',
        component: ClaimComponent,
        canActivate: [ClaimActiveGuard, GuideGuardService],
      },
      {
        path: 'messages',
        component: CommunicationsComponent,
        canActivate: [GuideGuardService],
      },
      {
        path: 'messages/:claim',
        component: CommunicationsComponent,
        canActivate: [ClaimActiveGuard, GuideGuardService],
      },
      {
        path: 'messages/chat/:thread',
        component: DetailsCommunicationComponent,
        canActivate: [GuideGuardService],
      },
      // {
      //   path: 'messages/new/:new',
      //   component: NewCommunicationComponent,
      // },
      {
        path: 'messages/new/:claim',
        component: NewCommunicationComponent,
        canActivate: [ClaimActiveGuard, GuideGuardService],
      },
      {
        path: 'thread/:id',
        component: ThreadComponent,
        canActivate: [GuideGuardService],
      },
      {
        path: 'claim/:cid/q/:qcode',
        component: QuestionnaireAnswerClientComponent,
        canActivate: [ClaimActiveGuard, GuideGuardService],
        canDeactivate: [UnsavedChangesGuard],
      },
      { path: 'faq', component: FaqComponent },
      { path: '**', redirectTo: 'home' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientRoutingModule {}
